// extracted by mini-css-extract-plugin
export default {"main-container":"Login_main-container__nSxFZ"};